import { Data } from 'signup-constants/signupData/Data';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmExperienceLevelView = () => {
  const options = DataOptions[Data.CrmExperienceLevel];
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    options: options
  });
};
export default CrmExperienceLevelView;